export const phoneRegExp = /^[+]?[0-9]{1,5}?[-\s]?[0-9]{0,2}?[-\s]?[0-9]{0,2}?[-\s]?[0-9]{0,4}[-\s]?[0-9]{0,4}$/im;
